import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";
import { useCallback, useEffect, useState } from "react";
import classNames from "classnames";

import BusinessTable from "../table";
import { getAllUsers } from "../../../setup/api/services/user";
import Pagination from "../pagination";
import { IUserInfoResponseData } from "../../../setup/api/services/user/models";
import SearchInput from "../../../components/common/searchInput";
import { ROUTES } from "../../../setup/constants";
import { useNavigate } from "react-router-dom";

const BusinessUsers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [pagesCount, setPagesCount] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const pageSize = 10;
  const [listUsers, setListUsers] = useState<
    (IUserInfoResponseData & { onClick: () => void })[]
  >([]);
  const [searchValue, setSearchValue] = useState("");

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [showAll, setShowAll] = useState<boolean>(true);

  const fetchUsersList = useCallback(
    async (page) => {
      try {
        const response = await getAllUsers(page - 1, pageSize, searchValue);
        setListUsers(
          response.data.content?.map((user) => ({
            ...user,
            onClick: () =>
              navigate(ROUTES.USER_DETAILS?.replace(":id", user?.id)),
          }))
        );
        setPagesCount(response.data.totalPages);
        setTotalCount(response.data.totalElements);
      } catch (error) {
        console.error;
      }
    },
    [searchValue]
  );

  useEffect(() => {
    try {
      fetchUsersList(currentPage);
    } catch (error) {
      console.error(error);
    }
  }, [fetchUsersList, currentPage, searchValue]);

  // Table columns configuration
  const columns = [
    { type: "user", value: "العميل" },
    { type: "phone", value: "رقم الجوال" },
    { type: "status", value: "التوثيق" },
  ];

  // Filter users based on search query

  // Render cell content based on column type and row data
  const renderCell = (columnType: string, row: unknown, rowIndex: number) => {
    const userData = row as IUserInfoResponseData;

    switch (columnType) {
      case "user":
        return (
          <div className={styles.userColumn}>
            <div className={styles.userAvatar}>
              <img
                src={
                  userData.profile?.photoUrl || "/assets/images/svg/user.svg"
                }
                alt={userData.profile.fullName}
              />
            </div>
            <div className={styles.userName}>{userData.profile.fullName}</div>
          </div>
        );
      case "phone":
        return <div className={styles.phoneNumber}>{userData.phoneNumber}</div>;
      case "status":
        return (
          <div
            className={classNames(
              styles.statusBadge,
              userData.nationalIdVerified
                ? styles.statusApproved
                : styles.statusNotApproved
            )}>
            {userData.nationalIdVerified ? "موثق" : "غير موثق"}
          </div>
        );
      case "actions":
        return (
          <div className={styles.actionMenu}>
            <button className={styles.actionButton}>
              <span className={styles.actionDots}>⋮</span>
            </button>
          </div>
        );
      default:
        return null;
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.pageTitle}>العملاء</h1>

        <div className={styles.headerControls}>
          <div className={styles.searchContainer}>
            <SearchInput
              dir="rtl"
              placeholder={t("lbl_search_by_phone_number")}
              value={searchValue}
              style={{ width: "204px", height: "40px", borderRadius: "10px" }}
              handleChange={(event) => {
                setSearchValue(event.target.value);
              }}
            />
          </div>
          {/* // TODO: Add the new actions later */}
          {/* <div className={styles.filterButtons}>
            <button
              className={classNames(
                styles.filterButton,
                showAll && styles.activeFilter
              )}
              onClick={() => setShowAll(true)}>
              الجميع
            </button>
            <button className={classNames(styles.exportButton)}>
              تصدير excel
            </button>
          </div> */}
        </div>
      </div>

      <div className={styles.tableContainer}>
        <BusinessTable
          columns={columns}
          rows={listUsers}
          renderCell={renderCell}
        />
      </div>

      <div className={styles.paginationContainer}>
        <Pagination
          countName={t("lbl_user")}
          pageSize={pageSize}
          pagesCount={pagesCount}
          page={currentPage}
          length={totalCount}
          handlePaginationChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default BusinessUsers;
